import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightText',
})
export class HighlightTextPipe implements PipeTransform {
  transform(value: string, keyword: string): unknown {
    const cleanedUpKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const regex = new RegExp(`(${cleanedUpKeyword})`, 'gi');
    return value.replace(regex, `<span class="text-highlight">$1</span>`);
  }
}
